__turbopack_context__.v({
  "Accordion": "Accordion2Column-module-sass-module__8AEcna__Accordion",
  "Accordion2Column": "Accordion2Column-module-sass-module__8AEcna__Accordion2Column",
  "Cont": "Accordion2Column-module-sass-module__8AEcna__Cont",
  "Copy": "Accordion2Column-module-sass-module__8AEcna__Copy",
  "Image": "Accordion2Column-module-sass-module__8AEcna__Image",
  "Intro": "Accordion2Column-module-sass-module__8AEcna__Intro",
  "Item": "Accordion2Column-module-sass-module__8AEcna__Item",
  "Main": "Accordion2Column-module-sass-module__8AEcna__Main",
  "Open": "Accordion2Column-module-sass-module__8AEcna__Open",
  "Title": "Accordion2Column-module-sass-module__8AEcna__Title",
});
